export const camelCaseToSnakeCase = (str) => {
    return str.replace(/([A-Z])/g, ($1) => '_' + $1).toUpperCase();
};
